import { Suspense } from "react";
import { Card, Stack, ToggleButton, ToggleButtonGroup } from "react-bootstrap";
import { CircleFill } from "react-bootstrap-icons";
import { Await, useRouteLoaderData } from "react-router-dom";
import { formatDemographicText } from "../HelperFunctions";

export const clocksRatingsColors = ["#FEBE10", "#A1EF8B", "#E87EA1", "#42CAFD"];

export default function ClocksRatingsCard({ data, ratingsLoading, error, showRatingsLabels, setShowRatingsLabels }) {
    const { demographics } = useRouteLoaderData("root");

    if (!data) return;

    return (
        <Card>
            <Card.Header className="fs-7">Ratings</Card.Header>
            <Card.Body className="py-1">
                <Stack className="mt-1">
                    {data.radios.map((x, i) => (
                        <Stack direction="horizontal" gap={1} key={x.demo_id}>
                            <CircleFill style={{ color: clocksRatingsColors[i] }} height={15} width={15} />
                            <span className="fs-8">
                                <Suspense fallback={<span>Ratings</span>}>
                                    <Await resolve={demographics}>
                                        {resolvedDemos => formatDemographicText(resolvedDemos.data.find(d => d.demo_id === x.demo_id))}
                                    </Await>
                                </Suspense>
                            </span>
                        </Stack>
                    ))}
                    <Stack direction="horizontal" gap={1}>
                        <CircleFill className="text-ra-dark-blue" height={15} width={15} />
                        <span className="fs-8">
                            <Suspense fallback={<span>Ratings (AVG)</span>}>
                                <Await resolve={demographics}>
                                    {resolvedDemos => <>{formatDemographicText(resolvedDemos.data.find(x => x.demo_id === data.radios[0].demo_id))} (AVG)</>}
                                </Await>
                            </Suspense>
                        </span>
                    </Stack>
                    <ToggleButtonGroup
                        type={"radio"}
                        name={`clocksRatingsLabels-${data.radios[0].radio_id}`}
                        value={showRatingsLabels}
                        onChange={setShowRatingsLabels}
                        className="mt-1 ra-switcher ra-switcher-sm ra-switcher-light-yellow">
                        <ToggleButton
                            id={`clocks-ratings-labels-none-${data.radios[0].radio_id}`}
                            variant={"ra-dark-blue-outline"}
                            value={0}
                            className="px-0 py-1 align-content-center">
                            Off
                        </ToggleButton>
                        <ToggleButton
                            id={`clocks-ratings-labels-5th-${data.radios[0].radio_id}`}
                            variant={"ra-dark-blue-outline"}
                            value={5}
                            className="px-0 py-1 align-content-center">
                            Every 5th
                        </ToggleButton>
                        <ToggleButton
                            id={`clocks-ratings-labels-all-${data.radios[0].radio_id}`}
                            variant={"ra-dark-blue-outline"}
                            value={1}
                            className="px-0 py-1 align-content-center">
                            All
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Stack>
            </Card.Body>
        </Card>
    );
}
